// extracted by mini-css-extract-plugin
module.exports = {"main":"reviews-module--main--1jYU7","grid":"reviews-module--grid--1bQJ2","buttons":"reviews-module--buttons--3Y8H4","btn":"reviews-module--btn--2BXmt"};